export default "__VITE_ASSET__fb0fb8d8__"